<p>
  <strong>
    {{preText  | translate}}
    <a href="" (click)="onRetry($event)">{{linkText  | translate}}</a>
  </strong>
</p>
